export const tr = {
    cancel: 'İptal',
    'crop-all-sizes': 'Tüm boyutları kırp',
    'crop-title': 'Görsel kırpma',
    'crop-updated-sizes': 'Değiştirilen boyutları kırp'
};
